import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import { toast, Toaster } from "sonner";

export default function Following() {
  const [pros, setPros] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/users/following").then(r => { setPros(r.data || []); }).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const unfollow = async (id) => {
    try {
      await api.post(`/users/unfollow/${id}`);
      setPros(p => p.filter(x => x.user_id !== id));
      toast.success("Unfollowed");
    } catch { toast.error("Could not unfollow"); }
  };

  // group by category
  const groups = pros.reduce((acc, p) => {
    const c = p.category || "Other";
    (acc[c] = acc[c] || []).push(p);
    return acc;
  }, {});
  const cats = Object.keys(groups).sort();

  return (
    <div>
      <Header/>
      <Toaster position="top-center"/>
      <section className="px-6 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Following</h1>
            <Link to="/feed" className="text-sm text-[#245544] font-semibold">← Back to feed</Link>
          </div>

          {loading ? (
            <p className="text-[#222]/40 py-10 text-center">Loading…</p>
          ) : pros.length === 0 ? (
            <div className="bg-white rounded-2xl p-10 text-center border border-dashed border-black/15" data-testid="following-empty">
              <p className="text-[#222]/60 mb-4">You're not following anyone yet.</p>
              <Link to="/search" className="btn-lime px-5 py-2 text-sm">Browse pros</Link>
            </div>
          ) : (
            <div className="space-y-8" data-testid="following-groups">
              {cats.map(cat => (
                <div key={cat}>
                  <h2 className="text-sm uppercase tracking-wider text-[#222]/50 font-bold mb-3">{cat} <span className="text-[#222]/30">({groups[cat].length})</span></h2>
                  <div className="space-y-2">
                    {groups[cat].map(p => (
                      <div key={p.user_id} className="bg-white rounded-2xl p-3 shadow-sm border border-black/5 flex items-center gap-3" data-testid={`following-row-${p.user_id}`}>
                        <Link to={`/pro/${p.user_id}`} className="shrink-0">
                          {p.avatar_url
                            ? <img src={p.avatar_url} className="w-11 h-11 rounded-full object-cover" alt=""/>
                            : <div className="w-11 h-11 rounded-full bg-[#2E6B57] grid place-items-center font-bold">{p.business_name?.[0]}</div>}
                        </Link>
                        <div className="flex-1 min-w-0">
                          <Link to={`/pro/${p.user_id}`} className="font-semibold text-sm hover:underline" style={{ fontFamily: "Outfit" }}>{p.business_name}</Link>
                          <p className="text-xs text-[#222]/50 truncate">{p.city}</p>
                        </div>
                        <button onClick={() => unfollow(p.user_id)} className="text-xs px-4 py-1.5 rounded-full border border-black/10 bg-white hover:bg-black/5" data-testid={`unfollow-${p.user_id}`}>Unfollow</button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
